import { render, staticRenderFns } from "./ClassCSAT10.vue?vue&type=template&id=1eb573e5&"
import script from "./ClassCSAT10.vue?vue&type=script&lang=ts&"
export * from "./ClassCSAT10.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports